import request from '@/utils/request'

//自动组卷
export function AutoPaper(cateIds,subjectIds,data) {
    return request({
        url: `/api/Exam/AutoQuestionList?cateIds=${cateIds}&subjectIds=${subjectIds}`,
        method: 'post',
        data
    })
}

//查询自动组卷
export function SelectAutoPaper(params) {
    return request({
        url: '/api/Exam/AutoZuJuanList',
        method: 'get',
        params
    })
}